import {TUserEquity} from "@/api/auth";

export enum UserActionTypes {
    InitUserToken = 'InitUserToken',
    InitUserVideoBalance = 'InitUserVideoBalance',
    InitVipWeekV24_03_04EndTime = 'InitVipWeekV24_03_04EndTime',
    InitVipMonthV24_03_04EndTime = 'InitVipMonthV24_03_04EndTime',
}


export const ActInitUserToken = (payload: string) => ({
    type: UserActionTypes.InitUserToken,
    payload
})


export const ActInitUserVideoBalance = (payload: TUserEquity['video_balance']) => ({
    type: UserActionTypes.InitUserVideoBalance,
    payload
})

export const ActInitVipWeekV24_03_04EndTime = (payload: number) => ({
    type: UserActionTypes.InitVipWeekV24_03_04EndTime,
    payload
})

export const ActInitVipMonthV24_03_04EndTime = (payload: number) => ({
    type: UserActionTypes.InitVipMonthV24_03_04EndTime,
    payload
})


export type UserActions = ReturnType<typeof ActInitUserToken | typeof ActInitUserVideoBalance>
